













import Vue, { PropType } from 'vue';
import { IContract } from '@/models';

export default Vue.extend({
  name: 'ContractRenewalBanner',

  props: {
    contract: { type: Object as PropType<IContract>, required: true }
  },

  computed: {
    getBannerColor(): string {
      return this.contract.isInThirtyDayDurationThreshold()
        ? 'cancel'
        : 'orange';
    }
  }
});
